module.exports = __webpack_public_path__ + "img/exam-no-pass.9597a6ef.png";